<template>
    <div v-if="options_loaded && passed_filter && panel_required">
        <div class="designeroption" :data-designer-component-id="component_id">
            <h3 v-if="title">{{ title }}</h3>
            <div :id="'radio--' + component_id">
                <div v-if="options_loaded && passed_filter">
                    <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
                        <span>Add Trim Packs?</span>
                        <span v-for="option in filtered_option_list"><label class="mr-3"><input type="radio" v-model="localTarget"
                                                                                                :name="'radio_' + component_id"
                                                                                                :value="option.value"/> {{ option.label }}</label></span>
                    </div>
                    <div v-if="loading">
                        <p>Loading Options</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import RadioQuestion from "./mixin/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Trim Packs';
                }
            },
            component_id: {
                default(){
                    return 'trim_packs';
                }
            },
            frameProfile: {
                required: true,
            },
            colourRange: {
                required: true,
            }
        },
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/trim-packs?profile=' + this.frameProfile + '&colour_range=' + this.colourRange;
            },
            cache_key(){
                return '_' + this.frameProfile +  '_' + this.colourRange;
            },
        },
        watch: {
            'cache_key': function (newVal, oldVal) {
                this.update_options();
            },
        }
    }
</script>
